<template>
    <div>

        <search v-model="search" @search="fetchContacts" placeholder="Search by contact name..."/>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label>By Location</label>
                    <select class="form-control select-filter" v-model="location">
                        <option value="" selected>All</option>
                        <option v-for="location in locations" :value="location.id">
                            {{ location.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label>By Campaign</label>
                    <select class="form-control select-filter" v-model="campaign" @change="fetchContacts()">
                        <option value="" selected>All</option>
                        <option v-for="campaign in campaigns" :value="campaign.id">
                            {{ campaign.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <card-spinner style="height: 240px;" v-if="loading"></card-spinner>

        <div class="alert alert-warning" role="alert" v-if="!loading && !contacts.data.length">
            Not results to display.
        </div>

        <div class="card card-default" v-if="!loading && contacts.data.length">
            <div class="card-header">
                Follow-up's Report
            </div>

            <table class="table table-valign-middle table-striped mb-0">
                <thead>
                <tr>
                    <th class="th-fit"></th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                </tr>
                </thead>

                <tbody>
                    <template v-for="(contact, index) in contacts.data">
                        <tr>
                            <td class="table__child-row" @click="showDetails(index)">
                                <span class="fas fa-chevron-right table__child-row-toggle"
                                    :class="{ 'table__child-row-toggle--open': contact.showDetails }"></span>
                            </td>

                            <td>
                                {{ contact.name }}
                            </td>

                            <td>
                                {{ contact.phone }}
                            </td>

                            <td>
                                {{ contact.email }}
                            </td>
                        </tr>
                        <tr v-if="contact.showDetails">
                            <td colspan="4">
                                <div class="message__details" v-for="message in contact.messages">
                                    <div class="row">
                                        <div class="col-6">
                                            <p class="m-0">
                                                <b>Location:</b>
                                                {{ message.location_name }}</p>
                                            <p class="m-0">
                                                <i class="fa fa-map-marker-alt"></i>
                                                {{ message.location_address }}
                                            </p>
                                        </div>
                                        <div class="col-6">
                                            <p class="m-0">
                                                <b>Campaign:</b>
                                                {{message.campaign_name}}
                                            </p>
                                            <p class="m-0">
                                                <b>Sent:</b>
                                                {{message.created_at}}
                                            </p>
                                        </div>
                                        <div class="col">
                                            <p class="mt-2">
                                                <b>Message:</b>
                                                {{message.content}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

        </div>
        <pagination
            v-if="contacts.meta.last_page > 1"
            :meta="contacts.meta"
            :links="contacts.links"
            @page="gotoPage"
        />
    </div>
</template>

<script>

    export default {
        props: {
            locations: {
                required: true,
                type: Array
            }
        },

        data() {
            return {
                loading  : true,
                search   : null,
                location : '',
                campaign : '',
                campaigns: [],
                contacts : {
                    data : [],
                    meta : '',
                    links: '',
                },
            }
        },

        watch: {
            location() {
                this.campaigns = [];
                this.campaign  = '';

                this.locations.filter((location) => {
                    if (location.id === this.location) {
                        this.campaigns = location.campaigns;
                    }
                });

                this.fetchContacts();
            }
        },

        created() {
            this.fetchContacts().then(() => this.loading = false );
        },

        methods: {
            fetchContacts(page = 1) {
                this.loading = true;
                let params   = {
                    page    : page,
                    search  : this.search,
                    location: this.location,
                    campaign: this.campaign
                };
                return this.$http.get(this.$laroute.route('reports.follow-up.index'), {params})
                    .then(({data}) => {
                        this.loading  = false;
                        this.contacts.meta = data.meta;
                        this.contacts.links = data.links;
                        this.setShowDetails(data.data);
                    });
            },

            showDetails(index) {
                this.contacts.data[index].showDetails = !this.contacts.data[index].showDetails;

                if (this.contacts.data[index].showDetails && !this.contacts.data[index].messages.length) {
                    this.getMessages(index, this.contacts.data[index].id)
                }
            },

            async getMessages(index, contact) {
                const params = {
                    contact : contact,
                    location: this.location,
                    campaign: this.campaign
                };
                await this.$http.get(this.$laroute.route('reports.follow-up.messages'), {params})
                    .then(({data}) => {
                        this.contacts.data[index].messages = data;
                    });
            },

            gotoPage(page) {
                this.loading = true;
                this.contacts.data = [];
                this.fetchContacts(page).then(() => this.loading = false);
            },

            setShowDetails(contacts) {
                this.contacts.data = [];
                contacts.map((contact) => {
                    contact.showDetails = false;
                    contact.messages = '';
                    this.contacts.data.push(contact);
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .table__child-row {
        cursor: pointer;
    }

    .table__child-row-toggle {
        transition: transform .3s ease-in-out;
    }

    .table__child-row-toggle--open {
        transform: rotate(90deg);
        transition: transform .3s ease-in-out;
    }

    .message__details:not(:first-child) {
        margin-top: 1rem;
        padding-top: 1rem;
        border-top: 1px solid rgba(0, 0, 0, .1);
    }
</style>
